// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "grade_from": {
      "column": {
        "default": null,
        "name": "grade_from",
        "null": true,
        "type": "integer"
      },
      "name": "grade_from",
      "selected_by_default": null,
      "translated": null
    },
    "grade_to": {
      "column": {
        "default": null,
        "name": "grade_to",
        "null": true,
        "type": "integer"
      },
      "name": "grade_to",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_students": {
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      },
      "name": "number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "student_friendly_commune_invoicing": {
      "column": {
        "default": true,
        "name": "student_friendly_commune_invoicing",
        "null": false,
        "type": "boolean"
      },
      "name": "student_friendly_commune_invoicing",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_students_with_fallback": {
      "column": null,
      "name": "number_of_students_with_fallback",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "StudentCouncil",
  "collectionKey": "student_councils",
  "collectionName": "student_councils",
  "i18nKey": "student_council",
  "camelizedLower": "studentCouncil",
  "name": "StudentCouncil",
  "nameDasherized": "student-council",
  "pluralName": "student_councils",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "student_council_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "school_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "schools",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": "school_contacts"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "grade_from",
      "column": {
        "default": null,
        "name": "grade_from",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "grade_to",
      "column": {
        "default": null,
        "name": "grade_to",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "number_of_students",
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "student_friendly_commune_invoicing",
      "column": {
        "default": true,
        "name": "student_friendly_commune_invoicing",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "student_council_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "student_council",
  "primaryKey": "id"
}

/** Frontend model for StudentCouncil. */
export default class StudentCouncil extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number | null} */
  gradeFrom() {
    return this.readAttributeUnderscore("grade_from")
  }

  /** @returns {boolean} */
  hasGradeFrom() {
    const value = this.gradeFrom()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  gradeTo() {
    return this.readAttributeUnderscore("grade_to")
  }

  /** @returns {boolean} */
  hasGradeTo() {
    const value = this.gradeTo()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  numberOfStudents() {
    return this.readAttributeUnderscore("number_of_students")
  }

  /** @returns {boolean} */
  hasNumberOfStudents() {
    const value = this.numberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  studentFriendlyCommuneInvoicing() {
    return this.readAttributeUnderscore("student_friendly_commune_invoicing")
  }

  /** @returns {boolean} */
  hasStudentFriendlyCommuneInvoicing() {
    const value = this.studentFriendlyCommuneInvoicing()

    return this._isPresent(value)
  }

  /** @returns {any} */
  numberOfStudentsWithFallback() {
    return this.readAttributeUnderscore("number_of_students_with_fallback")
  }

  /** @returns {boolean} */
  hasNumberOfStudentsWithFallback() {
    const value = this.numberOfStudentsWithFallback()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["student_council_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }
}
